import * as Animate from "react-reveal";

const EPISODE_URL = "https://open.spotify.com/episode/0z7MleCXvfcq3WnN6MwhaV";

const PodcastCtaSection = () => {
  return (
    <section className="bg-primary text-white">
      <Animate.Fade bottom>
        <div
          className="mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-center gap-[30px] lg:gap-[70px] px-[18px] sm:px-[26px] py-[68px] lg:py-20"
          style={{ maxWidth: "1280px" }}
        >
          <div>
            <p className="flex items-center gap-3 text-secondary tracking-[0.1em] text-[14px] font-extrabold leading-[1.45] mb-5">
              <span className="w-[34px] h-[3px] bg-secondary inline-block shrink-0" />
              YOUR NEXT STEP
            </p>
            <h2
              className="tracking-[-0.045em] max-w-[900px] mb-[14px]"
              style={{ fontSize: "clamp(31px, 4vw, 52px)", lineHeight: 1.14 }}
            >
              Take an experienced voice into your next walk, drive or work
              session.
            </h2>
            <p
              className="max-w-[760px] text-[17px] leading-[1.72] m-0"
              style={{ color: "#d7dfff" }}
            >
              Start with a featured episode and keep learning through the Utiva
              resource ecosystem.
            </p>
          </div>
          <a
            href={EPISODE_URL}
            target="_blank"
            rel="noreferrer"
            className="bg-secondary border border-secondary text-primary rounded-xl inline-flex items-center justify-center gap-[11px] text-[15px] font-bold px-[22px] shrink-0 w-full lg:w-auto hover:bg-[#ffc342] transition-colors"
            style={{ minHeight: "54px" }}
          >
            Play the podcast <span aria-hidden="true">↗</span>
          </a>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default PodcastCtaSection;
